import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { isMobileStyleMixin } from '@amzn/storm-ui';

const imageSizes = {
  small: '300x300',
  base: '400x300',
  medium: '600x300'
};
const ImageContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1ee6iva-0"
})(["display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-content:stretch;align-items:center;margin:0 ", ";", " img{background-color:", ";max-width:unset;height:", "px;width:", "px;border:white solid 10px;border-radius:", ";box-shadow:", ";", "}"], ({
  theme
}) => theme.spacing.base, isMobileStyleMixin(css(["margin:0;"])), ({
  theme
}) => theme.palette.gray[0], ({
  size
}) => +imageSizes[size !== null && size !== void 0 ? size : 'base'].split('x')[1], ({
  size
}) => +imageSizes[size !== null && size !== void 0 ? size : 'base'].split('x')[0], ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.boxShadow, isMobileStyleMixin(css(["max-width:calc(100% - ", ");height:auto;"], ({
  theme
}) => theme.spacing.base)));
const MediaContainer = ({
  size = 'base',
  src,
  alt,
  ...props
}) => /*#__PURE__*/React.createElement(ImageContainer, {
  size: size
}, /*#__PURE__*/React.createElement("img", _extends({
  src: src,
  alt: alt
}, props)));
MediaContainer.propTypes = {
  /**
   * Alt text that describes the content of the image for accessability.
   */
  alt: PT.string.isRequired,
  /**
   * Size of the media area.
   * -  small  = '300x300'
   * -  base   = '400x300'
   * -  medium = '600x300'
   */
  size: PT.oneOf(['small', 'base', 'medium']),
  /**
   * URL of the image.
   */
  src: PT.string.isRequired
};
MediaContainer.defaultProps = {
  size: 'base'
};

export { MediaContainer as M };
//# sourceMappingURL=MediaContainer-oMjhUhE4.js.map
